import React, { useState } from "react";
import { X } from "lucide-react";
import { PageBanner, SectionTitle } from "../components/Shared";
import { GALLERY_IMGS } from "../data/siteData";
import "./InnerPages.css";

const GalleryPage = () => {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <PageBanner title="Photo Gallery" breadcrumb="Gallery" />
      <section className="section">
        <div className="container">
          <SectionTitle
            title="School Gallery"
            subtitle="Glimpses of academics, activities, and celebrations at IDPS Mahore."
          />
          <div className="gallery-grid">
            {GALLERY_IMGS.map((img, i) => (
              <div
                key={i}
                className="gallery-grid__item"
                onClick={() => setSelected(img)}
              >
                <img src={img} alt={`Gallery ${i + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selected && (
        <div className="lightbox" onClick={() => setSelected(null)}>
          <img src={selected} alt="Gallery" className="lightbox__img" />
          <button className="lightbox__close" aria-label="Close"><X size={22} /></button>
        </div>
      )}
    </>
  );
};

export default GalleryPage;
